import React from 'react';
import { IonModal, IonContent } from '@ionic/react';
import Button from '../../../../components/atoms/button';
import './CreateBuildingsWalletModal.css';

interface CreateBuildingsWalletModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateBuildingsWallet: () => void;
}

const CreateBuildingsWalletModal: React.FC<CreateBuildingsWalletModalProps> = ({
  isOpen,
  onClose,
  onCreateBuildingsWallet
}) => {
  const handleCreate = () => {
    onCreateBuildingsWallet();
    onClose();
  };

  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.7}
      breakpoints={[1, 1, 1, 1]}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
    >
      <IonContent>
        <div className="create-buildings-wallet-modal-content w-full h-full pt-4 flex flex-col justify-start items-center">
          <p className="font-bold text-primaryColor100 text-2xl">
            هل ترغب بإضافة هذه القطعة إلى محفظتك ؟
          </p>
          <div className="w-full mt-4 px-4 grid grid-cols-2 gap-4">
            <Button
              theme={"primary"}
              text={"موافق"}
              size={"big"}
              onClick={handleCreate}
            />
            <Button
              theme={"danger"}
              text={"إغلاق"}
              size={"big"}
              onClick={onClose}
            />
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default CreateBuildingsWalletModal;
